export const formatNumberWithSpace = (number: number) => {
  return new Intl.NumberFormat('fr-FR').format(number);
};
